export const tracingEmptyStateRouteName = 'dashboard.tracing-trial';
export const metricsEmptyStateRouteName = 'dashboard.metrics-trial';
export const siemEmptyStateRouteName = 'dashboard.security-trial';
export const logsEmptyStateRouteName = 'dashboard.logs-trial';
